import { FC } from 'react';

export const VersionNumber: FC = () => {
	return <span>0.2</span>;
};
